<template>
    <tr>
        <td>
            <Badge :type="badgeType">
                {{ youbuydaField }}
                <span v-if="youbuydaField === 'identifier'">
                    ({{ identifier }})
                </span>
            </Badge>
        </td>
        <td>
            {{ __('stock-upload.field_descriptions.' + youbuydaField) }}
            <span v-if="youbuydaField === 'channels'">
                <ConfigureStockChannelsModal :visible="configureChannelsVisible"
                                             @hide="configureChannelsVisible = false"
                />
                <a href="javascript:void(0);" @click="configureChannelsVisible = !configureChannelsVisible">
                    Configure your channels.
                </a>
            </span>
        </td>
        <td class="d-none d-lg-table-cell">
            <i class="fas fa-arrow-circle-right text-muted"/>
        </td>
        <td>
            <div class="d-flex flex-row">
                <div class="flex-grow-1 dropdown">
                    <button class="btn btn-sm btn-block btn-default text-left dropdown-toggle"
                            :class="{'rounded-right-0': isOptional}"
                            style="min-width: 100px;"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                    >
                        {{ assignedColumn }}
                    </button>
                    <div class="dropdown-menu">
                        <div v-for="(feedValue, feedColumn) in exampleValues"
                             class="dropdown-item cursor-pointer"
                             @click="$emit('change', youbuydaField, feedColumn)"
                        >
                            <div class="d-flex flex-column">
                                <div>{{ feedColumn }}</div>
                                <div class="font-size-sm text-muted">
                                    Example: {{ feedValue }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button v-if="isOptional"
                        class="btn btn-sm btn-default btn-hover-danger rounded-left-0"
                        @click="$emit('delete', youbuydaField)">
                    <i class="fas fa-trash"/>
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
import Badge from "../../Badge.vue";
import ConfigureStockChannelsModal from "./ConfigureStockChannelsModal.vue";

export default {
    components: {ConfigureStockChannelsModal, Badge},

    props: {
        exampleValues: Object,
        assignedColumn: String,
        youbuydaField: String,
        identifier: String,
        isOptional: Boolean
    },

    data() {
        return {
            configureChannelsVisible: false
        }
    },

    computed: {
        isAssigned() {
            return this.assignedColumn !== null && this.assignedColumn.trim().length > 0
        },

        badgeType() {
            return `badge-${this.colorType}`
        },

        colorType() {
            if (this.isAssigned) {
                return 'secondary';
            }

            if (this.youbuydaField === 'price') {
                return 'warning';
            }

            return 'danger'
        }
    }
}
</script>
